import style from './expertise.module.scss';
import Image from 'next/image';
import Link from 'next/link';
import Breadcrumbs from '../shared/miscellaneous/breadcrumbs/breadcrumbs';
import { TextImageBlock } from '@components/shared/blocks/text-image-block';
import { CardSmall } from '@components/shared/card-types/card-small';
import { ButtonHandshkaeGreen } from '@components/shared/buttons/button-handshake-green';

const ExpertiseComponent = () => {
  const expertiseState = {
    buttonIcon: '/assets/icons/icn-arrow-right.svg',
    technical: [
      {
        title: 'DevOps and Cloud',
        icon: '/expertise-images/technical-icons/cloud_icn.png',
      },
      {
        title: 'UX/UI Design',
        icon: '/expertise-images/technical-icons/ui_icn.png',
      },
      {
        title: 'High Load Systems',
        icon: '/expertise-images/technical-icons/load_icn.png',
      },
      {
        title: 'Internet of Things',
        icon: '/expertise-images/technical-icons/iot_icn.png',
      },
      {
        title: 'Analytics and Big Data',
        icon: '/expertise-images/technical-icons/analytics_icn.png',
      },
      {
        title: 'Cybersecurity',
        icon: '/expertise-images/technical-icons/security_icn.png',
      },
    ],
    cards: [
      {
        title: 'Media',
        text: 'Media platforms enable product active demonstration, impressive audience reach (both local and national), and specific audience targeting. Having a high impact, the solutions serve as a major source of news.',
        link: '/blog/is-an-event-discovery-app-a-worthwhile-business-idea',
      },
      {
        title: 'Marketplace & eCommerce',
        text: 'eCommerce marketplaces represent a safe place to carry out selling and purchasing operations, offering the audience high security level, convenience in application, and positive shopping experience.',
        link: '/blog/ultimate-guide-on-how-to-create-an-nft-marketplace',
      },
      {
        title: 'IoT',
        text: 'Such solutions ‌automate routine tasks, ensure higher effectiveness of platform use and enable a higher production rate. IoT helps business owners to better understand the needs and behavior of clients.',
        link: '/blog/iot-payment-application-of-the-iot-technology-in-payment',
      },
      {
        title: 'Pharmacy',
        text: 'Cloud-based pharmacy software serves to smoothly manage the inventory and stock replenishment, handle multiple prescription flows, maximize pharmaceutical products turnover ratio, and drive revenue.',
        link: '/blog/7-reasons-why-your-pharmacy-needs-an-app-pharmacy-app-development',
      },
      {
        title: 'Healthcare',
        text: 'We develop robust HIPAA-compliant software that allows managing billing, virtually visiting doctors, dealing with healthcare data, sharing files, assisting patients, handling profit and practice.',
        link: '/blog/mobile-healthcare-app-development-future-of-healthcare',
      },
      {
        title: 'Real estate',
        text: 'Custom-made real estate software helps to successfully run your real property business by streamlining your day-to-day activities, building up clients’ satisfaction, raising your enterprise profit.',
        link: '/blog/proptech-and-other-digital-transformations-in-real-estate',
      },
      {
        title: 'Transportation & Logistics',
        text: 'We develop tailored logistics software that streamlines warehousing, vehicle handling, and supply chain optimization to harness efficient and smart transportation business management.',
        link: '/blog/blockchain-in-logistics-how-the-blockchain-technologies-are-changing-the-transportation-industry',
      },
      {
        title: 'Financial services',
        text: 'Top-notch FinTech platforms allow financial institutions to optimize risk control and unleash their Big Data potential by the introduction of ML tools and cutting-edge analytical implements.',
        link: '/expertise/fintech',
      },
    ],
  };
  return (
    <>
      <Breadcrumbs />
      <section className={`${style.section} ${style.section_light}`}>
        <div className={`${style.container} ${style.container_large}`}>
          <TextImageBlock
            asTitle={true}
            title={'Agilie’s Competence and Expertise'}
            text={[
              'With the leading-edge knowledge and skills in producing advanced software, Agilie assists you in pursuing your commercial goals in conformity with the time frames, expectations, and finances you have.',
            ]}
            imageSrc={'/expertise-images/introduction.png'}
            imageAlt={'Competence and Expertise'}
          />
        </div>
      </section>
      <section className={`${style.section} ${style.section_gray}`}>
        <div className={`${style.container} ${style.container_small}`}>
          <div className={style.technical}>
            <h2 className={style.technical__title}>Technical Expertise</h2>
            <div className={style.technical__text}>
              Bringing over 10 years of technical experience and strategic planning, Agilie provides technological
              excellence by building remarkable IT solutions enhanced with cost-efficient and powerful mechanisms,
              namely:
            </div>
            <div className={style.technical__items}>
              {expertiseState.technical.map((item: any, index: number) => {
                return (
                  <div key={index} className={style.technical__item}>
                    <CardSmall title={item.title} iconSrc={item.icon} width={'60px'} height={'60px'} />
                  </div>
                );
              })}
            </div>
            <div className={style.technical__text}>
              Agilie also offers fully-fledged frameworks for entrepreneurs planning to expand their companies. Our
              professionals deliver comprehensive solutions, enabling organizations to grow and mature.
            </div>
            <ButtonHandshkaeGreen
              className="white-with-border"
              text="Learn More"
              link="/expertise/technology"
              imageUrl={expertiseState.buttonIcon}
            />
          </div>
        </div>
      </section>
      <section className={`${style.section} ${style.section_light}`}>
        <div className={`${style.container} ${style.container_small}`}>
          <div className={style.technical}>
            <h2 className={style.technical__title}>Software for Business Sustainability</h2>
            <div className={`${style.technical__text} ${style.technical__text_list}`}>
              Sophisticated digital platforms created by Agilie serve to ensure business continuity as well. The
              technologies our specialists apply allow accurately finalizing and launching the projects, duly
              implementing advanced functionality, expanding the team for reaching relevant commercial goals. We
              seriously take:
            </div>
            <ul className={style.technical__list}>
              <li>Deadline compliance</li>
              <li>Staff retention</li>
              <li>Client success management</li>
              <li>Delivery optimization</li>
            </ul>
            <div className={`${style.technical__text} ${style.technical__text_last}`}>
              The Agilie’s enhanced engineering procedures together with the technology competence of each team member
              serve to develop and streamline exceptional IT software to comprehensively pursue your business goals, and
              always evolving market pull.
            </div>
          </div>
        </div>
      </section>
      <section className={`${style.section} ${style.section_gray}`}>
        <div className={`${style.container} ${style.container_large}`}>
          <TextImageBlock
            title={'Fully-Fledged Solutions To Expand Your Business'}
            asSubTitle={true}
            text={[
              'Take advantage of the end-to-end package of our domain expertise to achieve sustainability and advancement of your company',
            ]}
            imageSrc={'/expertise-images/business.png'}
            imageAlt={'Fully-Fledged Solutions To Expand Your Business'}
          />
          <div className={style.card__items}>
            {expertiseState.cards.map((item: any, index: number) => {
              return (
                <div key={index} className={style.card__item}>
                  <h3 className={style.card__item__title}>{item.title}</h3>
                  <div className={style.card__item__text}>{item.text}</div>
                  <ButtonHandshkaeGreen
                    className="white-with-border"
                    text="Learn More"
                    link={item.link}
                    imageUrl={expertiseState.buttonIcon}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <section className={`${style.section} ${style.section_light}`}>
        <div className={`${style.container} ${style.container_large}`}>
          <div className={`${style.introduction__block}`}>
            <div className={style.introduction__block__text}>
              <h2 className={style.introduction__block__text__title}>Building Excellent Software Solutions</h2>
              <div className={style.introduction__block__text__subtext}>
                Agilie recognizes the importance of the Software Development Life Cycle (
                <Link href={'/blog/what-is-the-software-development-life-cycle-sdlc-and-how-does-it-work'}>
                  <a className={style.link}>SDLC</a>
                </Link>
                ) and its connection with designing top-quality digital products. We have the expertise to
                professionally carry out the Discovery phase as part of SDLC to ensure our clients obtain
                high-performance web and mobile platforms to boost their business success.
              </div>
              <ButtonHandshkaeGreen
                imageUrl={expertiseState.buttonIcon}
                className="white-with-border"
                text="Learn More"
                link="/expertise/insights"
              />
            </div>
            <div className={style.introduction__block__image}>
              <Image
                alt="Building Excellent Software Solutions"
                src={'/expertise-images/end.png'}
                layout={'fill'}
                sizes="300px"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ExpertiseComponent;
